export const defaultColumns = [
  {
    name: 'text',
    tree: true,
    width: 200,
    resize: true,
  },
  {
    name: 'start_date',
    align: 'center',
    resize: true,
    width: 90,
  },
  {
    name: 'duration',
    align: 'center',
  },
  {
    name: 'progress',
    label: 'Progress',
    align: 'center',
    template: (task: any) => `${Math.round(task.progress * 100)}%`,
  }
];

export const additionalColumn = { name: "add", label: "", width: 44 };

export const viewScales: Array<{
  title: string;
  value: 'day' | 'week' | 'month' | 'hours' | 'quater' | 'year';
}> = [
  {
    title: 'Day',
    value: 'day',
  },
  {
    title: 'Week',
    value: 'week',
  },
  {
    title: 'Month',
    value: 'month',
  },
  {
    title: 'Hours',
    value: 'hours',
  },
];

export const supportedExports: Array<{
  title: string;
  value: 'pdf' | 'png' | 'xls' | 'p6';
}> = [
  {
    title: 'PDF',
    value: 'pdf',
  },
  {
    title: 'Image',
    value: 'png',
  },
  {
    title: 'Excel',
    value: 'xls',
  },
  {
    title: 'Primavera P6',
    value: 'p6',
  },
];
